import FrameTempleSearch from '@screens/frame/temple/search'

export default function FrameTempleSearchPage() {
  return <FrameTempleSearch />
}
